<script lang="ts">
  import { AppState } from '../../etc/stores';
  import Typography from './Typography.svelte';

  type TypeStyle = 'default' | 'medium' | 'small';

  export let textAlign: string = 'left';
  export let color: string = $AppState.theme.colors.typography;
  export let type: TypeStyle = 'default';
  export let component: string = 'p';
  export let bold: boolean = false;
</script>

<Typography
  {component}
  class="twism-type-style-{type} {bold ? 'twism-bold' : ''} {$$props.class ||
    ''}"
  {color}
  {textAlign}
  on:click
>
  <slot />
</Typography>

<style lang="scss">
  :global(.twism-type-style-default) {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }
  :global(.twism-type-style-medium) {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
  :global(.twism-type-style-small) {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  }
  :global(.twism-bold) {
    font-weight: 600;
  }
</style>
